import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button, FormText } from "reactstrap";
import Select from 'react-select';

export const FormElementsCreate = (props) => {
    const {
        methodAction,catwselement, id_elements_config, dataDatacatwselementSearch,
        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
        saveDeleteElements, validarFormElements, handleCreateElements,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,loading,
        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
        catwsprocess,validacionesElements,button
    } = props;


    //console.log(formValuesElements, "formValuesElements");
    return (
        <Form className='' role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>NOMBRE DEL ELEMENTO <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='text'
                                name="nameElement"
                                value={formValuesElements.nameElement}
                                onChange={handleInputChangeElements}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <Label className='col-form-label'>PROCESO:</Label>
                        <FormGroup>
                            <select
                                className="form-control form-control-sm input-air-primary"
                                name="id_process_configElement"
                                value={formValuesElements.id_process_configElement}
                                onChange={handleInputChangeElements}
                            >
                                <option value={0}>Selecciona una opción</option>
                                {
                                    catwsprocess.map(element => (
                                        <option key={element.id_process_config} value={element.id_process_config}>
                                            {element.name}
                                        </option>
                                    ))
                                }
                            </select>

                            <FormFeedback>Selecciones mínimo un proceso</FormFeedback>
                        </FormGroup>

                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>COMENTARIO <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='text'
                                name="commentElement"
                                value={formValuesElements.commentElement}
                                onChange={handleInputChangeElements}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>¿ES RESULTADO? <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <select
                                className="form-control form-control-sm input-air-primary"
                                name="is_result"
                                value={formValuesElements.is_result}
                                onChange={handleInputChangeElements}
                            >
                                <option value={0}>Selecciona una opción</option>
                                <option value={1}>SI</option>
                                <option value={2}>NO</option>
                            </select>
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>TIPO DE CAPTURA <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <select
                                className="form-control form-control-sm input-air-primary"
                                name="id_type_elementElement"
                                value={formValuesElements.id_type_elementElement}
                                onChange={handleInputChangeElements}
                            >
                                <option value={0}>Selecciona una opción</option>
                                <option value={1}>Texto Libre</option>
                                <option value={3}>Fecha y Hora</option>
                                <option value={4}>Opción Multiple</option>
                                <option value={5}>Hora</option>
                                <option value={6}>Fecha Simple</option>
                            </select>

                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button outline color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" outline color='danger' type='button'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}